import type { Product, SetupProgress } from "../registry/types";

/**
 * Selects the "active" product for the setup guide widget.
 *
 * Rule (matches the pure-derivation invariant from PR #41192):
 *   row exists ⟺ user has engaged with the new flow.
 * For legacy merchants (`disputes.enabled=true` already) we never insert
 * a row, so they have no active product → no widget surface.
 *
 * Pure function so the provider's render logic is testable independently.
 *
 * @param progressByProduct  the team's loaded progress rows, keyed by product
 * @param registeredProducts products that are currently registered in the
 *                            client-side registry (the order is the priority
 *                            for "first match wins")
 */
export function pickActiveProduct(
  progressByProduct: Partial<Record<Product, SetupProgress>>,
  registeredProducts: readonly Product[],
): Product | null {
  for (const product of registeredProducts) {
    if (progressByProduct[product]) {
      return product;
    }
  }
  return null;
}
